import { render, staticRenderFns } from "./PriceListForm.vue?vue&type=template&id=3bf5a965&"
import script from "./PriceListForm.vue?vue&type=script&lang=ts&"
export * from "./PriceListForm.vue?vue&type=script&lang=ts&"
import style0 from "./PriceListForm.vue?vue&type=style&index=0&id=3bf5a965&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports